module.exports = __webpack_public_path__ + "img/plus-in-circle.37a8a394.svg";